import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Table, Input, Dropdown, Menu, Button, Select, Modal } from 'antd';
import { DownOutlined, SearchOutlined } from '@ant-design/icons';
import NavbarDropshipping from '../navbarDropshipping/navbarDropshipping';
import './misPedidos.css';
import { render } from '@testing-library/react';
import { PDFDocument } from 'pdf-lib';

const { Option } = Select;

const ProductTablePedidos = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [filters, setFilters] = useState({
    estadoOrden: '',
    transportadora: '',
    estadoEnvio: '',
  });
  const [selectedItems, setSelectedItems] = useState([]);
  const usuario_id = localStorage.getItem('usuario_id');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`https://api.99envios.app/api/listar_ordenes/${usuario_id}`);
        const filteredData = response.data.filter(item => item.origen_creacion === 2);
        const formattedData = filteredData.map((item, index) => ({
          key: item.id?.toString() || index.toString(), // Usar ID real o index como fallback
          id: item.id || index + 1, // Usar ID real de la base de datos
          id_variacion: item.id_variacion || '',
          talla: item.talla || '',
          color: item.color || '',
          nombre_producto: item.nombre_producto,
          fecha_estado: item.fecha_estado,
          orderDateObj: new Date(item.fecha_estado), // Para ordenamiento
          estado_envio: item.estado_envio,
          transportadora: item.transportadora,
          valor_proveedor: item.valor_proveedor || 0,
          valor_total: item.valor_venta || 0,
          valor_utilidad: item.valor_utilidad || 0,
          numero_guia: item.preeenvio?.numero_preenvio || '',
          pdf: item.pdf || '',
          nombre_destinatario: item.preeenvio?.destinatario ? 
            `${item.preeenvio.destinatario.nombre || ''} ${item.preeenvio.destinatario.primer_apellido || ''}` : 
            'Sin destinatario',
          telefono_destinatario: item.preeenvio?.destinatario?.telefono || '',
          direccion_destinatario: item.preeenvio?.destinatario?.direccion || '',
          selected: false,
        }))
        .sort((a, b) => {
          const dateA = new Date(a.fecha_estado);
          const dateB = new Date(b.fecha_estado);
          return dateB - dateA; // Descendente: más reciente primero
        });
        console.log('Datos ordenados (Sucursal):', formattedData.slice(0, 5).map(item => ({ 
          id: item.id, 
          date: item.fecha_estado,
          formatted: new Date(item.fecha_estado).toLocaleDateString('es-CO') 
        })));
        setData(formattedData);
        setFilteredData(formattedData);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [usuario_id]);

  const columns = [
    {
      title: '',
      dataIndex: 'checkbox',
      key: 'checkbox',
      render: (_, record) => (
        <input
          type="checkbox"
          checked={record.selected}
          onChange={() => handleCheckboxChange(record.key)}
        />
      ),
    },
    {
      title: ' Numero de Guía',
      dataIndex: 'numero_guia',
      key: 'numero_guia',
      render: (value) => value ? value : 'Sin guía',
    },
    {
      title: 'Nombre del producto',
      dataIndex: 'nombre_producto',
      key: 'nombre_producto',
    },
    {
      title: 'Variación',
      dataIndex: 'variacion',
      key: 'variacion',
      render: (_, record) => {
        const idVariacion = record.id_variacion ? `ID: ${record.id_variacion}` : 'Sin variación';
        const talla = record.talla ? `Talla: ${record.talla}` : 'Sin talla';
        const color = record.color ? `Color: ${record.color}` : 'Sin color';
  
        return (
          <div>
            <p>{idVariacion}</p>
            <p>{talla}</p>
            <p>{color}</p>
          </div>
        );
      },
    },
    {
      title: 'Fecha de estado',
      dataIndex: 'fecha_estado',
      key: 'fecha_estado',
      sorter: (a, b) => new Date(b.fecha_estado) - new Date(a.fecha_estado),
      render: (date) => {
        const formattedDate = new Date(date).toLocaleDateString('es-CO', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
        return <span style={{ color: '#666' }}>{formattedDate}</span>;
      },
    },
    {
      title: 'Estado del Envío',
      dataIndex: 'estado_envio',
      key: 'estado_envio',
    },
    {
      title: 'Transportadora',
      dataIndex: 'transportadora',
      key: 'transportadora',
    },
    {
      title: 'Valor de Proveedor',
      dataIndex: 'valor_proveedor',
      key: 'valor_proveedor',
      render: (value) => `$${value.toLocaleString()}`,
    },
    {
      title: 'Valor Total',
      dataIndex: 'valor_total',
      key: 'valor_total',
      render: (value) => `$${value.toLocaleString()}`,
    },
    {
      title: 'Utilidad',
      dataIndex: 'valor_utilidad',
      key: 'valor_utilidad',
      render: (value) => `$${value.toLocaleString()}`,
    },
    {
      title: 'PDF',
      dataIndex: 'pdf',
      key: 'pdf',
      render: (value) => value ? (
        <a href={value} target="_blank" rel="noopener noreferrer">
          Ver PDF
        </a>
      ) : 'No disponible',
    },
  ];
  

  const handleCheckboxChange = (key) => {
    const updatedData = data.map(item => 
      item.key === key ? { ...item, selected: !item.selected } : item
    );
    setData(updatedData);
    setFilteredData(updatedData);
    setSelectedItems(updatedData.filter(item => item.selected).map(item => item.key));
  };

  const handleSearch = (value) => {
    setSearchText(value);
  };

  const handleFilterChange = (filterName, value) => {
    setFilters({ ...filters, [filterName]: value });
  };

  useEffect(() => {
    let result = data;
    if (searchText) {
      result = result.filter(
        (item) =>
          item.nombre_producto.toLowerCase().includes(searchText.toLowerCase()) ||
          item.numero_guia.toLowerCase().includes(searchText.toLowerCase()) ||
          item.nombre_destinatario.toLowerCase().includes(searchText.toLowerCase()) ||
          item.telefono_destinatario.includes(searchText)
      );
    }
    if (filters.estadoOrden) {
      result = result.filter((item) => item.estado_orden === parseInt(filters.estadoOrden));
    }
    if (filters.transportadora) {
      result = result.filter((item) => item.transportadora.toLowerCase() === filters.transportadora.toLowerCase());
    }
    if (filters.estadoEnvio) {
      result = result.filter((item) => item.estado_envio.toLowerCase() === filters.estadoEnvio.toLowerCase());
    }
    
    // Mantener el ordenamiento por fecha después de filtrar
    result = result.sort((a, b) => {
      const dateA = new Date(a.fecha_estado);
      const dateB = new Date(b.fecha_estado);
      return dateB - dateA; // Descendente: más reciente primero
    });
    
    setFilteredData(result);
  }, [searchText, filters, data]);

  // Modified downloadCombinedPDF to combine PDFs into one file
  const downloadCombinedPDF = async () => {
    const selectedData = data.filter(item => selectedItems.includes(item.key));
    
    if (selectedData.length === 0) {
      Modal.warning({
        title: 'Selección requerida',
        content: 'Por favor seleccione al menos un pedido para descargar.'
      });
      return;
    }
    
    // Filter items with PDF URLs
    const itemsWithPdf = selectedData.filter(item => item.pdf);
    const itemsWithoutPdf = selectedData.filter(item => !item.pdf);
    
    if (itemsWithPdf.length === 0) {
      Modal.warning({
        title: 'Sin PDFs',
        content: 'Ninguno de los pedidos seleccionados tiene PDF disponible.'
      });
      return;
    }
    
    // Notify about items without PDF
    if (itemsWithoutPdf.length > 0) {
      const itemIds = itemsWithoutPdf.map(item => item.numero_guia || 'Sin número').join(', ');
      Modal.warning({
        title: 'PDFs no disponibles',
        content: `Los siguientes pedidos no tienen PDF disponible: ${itemIds}`
      });
    }
    
    try {
      // Create a new PDF document
      const mergedPdf = await PDFDocument.create();
      
      // Fetch and combine all PDFs
      for (const item of itemsWithPdf) {
        try {
          const pdfResponse = await fetch(item.pdf);
          const pdfBytes = await pdfResponse.arrayBuffer();
          
          // Load the PDF
          const pdf = await PDFDocument.load(pdfBytes);
          
          // Get all pages from the current PDF
          const pages = await mergedPdf.copyPages(pdf, pdf.getPageIndices());
          
          // Add all pages to the merged PDF
          pages.forEach(page => mergedPdf.addPage(page));
        } catch (error) {
          console.error(`Error processing PDF for item ${item.id}:`, error);
        }
      }
      
      // Save the merged PDF
      const mergedPdfBytes = await mergedPdf.save();
      
      // Create a blob with the PDF data
      const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
      
      // Create a URL for the blob
      const url = URL.createObjectURL(blob);
      
      // Create a link to download the PDF
      const link = document.createElement('a');
      link.href = url;
      link.download = `pedidos_combinados_${new Date().toISOString().slice(0, 10)}.pdf`;
      document.body.appendChild(link);
      
      // Trigger the download
      link.click();
      
      // Clean up
      document.body.removeChild(link);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error combining PDFs:', error);
      Modal.error({
        title: 'Error',
        content: 'Error al combinar los PDFs. Por favor intente de nuevo.'
      });
    }
  };

  const menu = (
    <Menu>
      <Menu.Item key="1" onClick={downloadCombinedPDF}>Descargar PDFs seleccionados</Menu.Item>
    </Menu>
  );

  return (
    <>
      <NavbarDropshipping title="Órdenes y Envíos Bodega" />
      <div className='misPedidos'>
        <div className="misPedidos-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
          <div className="misPedidos-actions" style={{ display: 'flex', gap: '10px' }}>
            <Dropdown overlay={menu}>
              <Button type="primary" style={{ borderRadius: '8px' }}>
                Acciones <DownOutlined />
              </Button>
            </Dropdown>
            <Button type="default" style={{ borderRadius: '8px' }}>
              Exportar
            </Button>
          </div>
          <Input
            placeholder="Buscar por producto, guía, destinatario, teléfono..."
            prefix={<SearchOutlined />}
            style={{ width: 250, borderRadius: '8px' }}
            onChange={(e) => handleSearch(e.target.value)}
          />
        </div>
        <div style={{ marginBottom: '16px' }}>
          <Select
            style={{ width: 200, marginRight: '8px' }}
            placeholder="Filtrar por Transportadora"
            onChange={(value) => handleFilterChange('transportadora', value)}
          >
            <Option value="">Todas</Option>
            <Option value="interrapidisimo">Interrapidisimo</Option>
            <Option value="coordinadora">Coordinadora</Option>
            <Option value="servientrega">Servientrega</Option>
            <Option value="envia">Envia</Option>
          </Select>
          <Select
            style={{ width: 200 }}
            placeholder="Filtrar por Estado de Envío"
            onChange={(value) => handleFilterChange('estadoEnvio', value)}
          >
            <Option value="">Todos</Option>
            <Option value="creado">Creado</Option>
            <Option value="en_transito">En tránsito</Option>
            <Option value="entregado">Entregado</Option>
          </Select>
        </div>
        <div className="misPedidos-tabla" style={{ overflowX: 'auto' }}>
          <Table
            columns={columns}
            dataSource={filteredData}
            pagination={{
              pageSize: 10,
              showSizeChanger: false,
              showQuickJumper: false,
            }}
            scroll={{ x: 1500 }}
            locale={{ emptyText: 'No hay datos disponibles' }}
            rowKey="key"
          />
        </div>
      </div>
    </>
  );
};

export default ProductTablePedidos;
